import { SmileyAngryIcon, SmileyIcon, SmileyMehIcon } from '@phosphor-icons/react'

import { theme } from '@reveni-io/reveni-ui'

import { getReasonsFilters } from '@/metrics/helpers/helpers'

import { aggregatedSentiments } from './constants'

export const getTopicColor = ({ rank, isOther }, theme) => {
  if (isOther) return getOtherTopicColor(theme)

  return getTopicPalette()[rank - 1] || getOtherTopicColor(theme)
}

export const getAggregateSentimentLabel = (aggregatedSentiment, theme) => {
  return getSentimentTypes(theme)[aggregatedSentiment]?.aggregatedLabel || null
}

export const getSentimentPercentages = (counts, total) => {
  if (!total || !counts) return { positive: 0, neutral: 0, negative: 0 }

  const { positive, neutral, negative } = counts

  return {
    positive: Math.round((positive / total) * 100),
    neutral: Math.round((neutral / total) * 100),
    negative: Math.round((negative / total) * 100),
  }
}

export const getSentimentTypes = theme => {
  return {
    [aggregatedSentiments.positive]: {
      Icon: SmileyIcon,
      label: 'Positivo',
      aggregatedLabel: 'Principalmente positivo',
      iconColor: theme.colors.success.default,
      backgroundColor: theme.colors.outline.surface,
      borderColor: theme.colors.outline.surface,
    },
    [aggregatedSentiments.neutral]: {
      Icon: SmileyMehIcon,
      label: 'Neutro',
      aggregatedLabel: 'Principalmente neutro',
      iconColor: theme.colors.text.subtle,
      backgroundColor: theme.colors.disabled.surface,
      borderColor: theme.colors.border.default,
    },
    [aggregatedSentiments.negative]: {
      Icon: SmileyAngryIcon,
      label: 'Negativo',
      aggregatedLabel: 'Principalmente negativo',
      iconColor: theme.colors.danger.onSurface,
      backgroundColor: theme.colors.danger.surface,
      borderColor: theme.colors.accent.default,
    },
  }
}

export const getTopicPalette = () => {
  return [
    theme.legacy.colors.focus,
    theme.legacy.palette.pink.tone300,
    theme.legacy.colors.accent.default,
    theme.legacy.palette.teal.tone500,
    theme.legacy.palette.lilac.tone400,
    theme.legacy.palette.yellow.tone300,
    theme.legacy.palette.red.tone400,
    theme.legacy.palette.blue.tone200,
    theme.legacy.palette.green.tone200,
  ]
}

export const getOtherTopicColor = theme => {
  return theme.colors.border.default
}

export const getShowExchanges = (configurationPreferences, isUnifiedDashboard) => {
  return (
    !!isUnifiedDashboard ||
    !!configurationPreferences?.allows_exchanges ||
    !!configurationPreferences?.allows_instant_exchanges
  )
}

export const getReasonSummaryOrdering = ({ reasonsFilters, configurationPreferences, isUnifiedDashboard }) => {
  if (!isUnifiedDashboard && !configurationPreferences) return null

  return getReasonsFilters(reasonsFilters, getShowExchanges(configurationPreferences, isUnifiedDashboard)).ordering
}

export const getIsReasonSummaryPending = ({ summary, loading, error }) => !error && (loading || !summary)
